import { Box, Container, Grid2, Typography } from "@mui/material";
import { Apartment } from "@mui/icons-material";
import { useGetAvailableUnitsQuery } from "../../features/units/api/unitsApiSlice";
import Spinner from "../Spinner";
// import PublicUnitCard from "./PublicUnitCard";
import PublicUnitCard from "./PublicUnitCardPG";

const PublicUnitGrid = ({ property }) => {
  const {
    data: units,
    isLoading: isUnitsLoading,
    isSuccess: isUnitsSuccess,
  } = useGetAvailableUnitsQuery(property.id);

  return (
    <>
      {isUnitsLoading ? (
        <Spinner />
      ) : (
        <>
          {units && units.ids.length !== 0 && (
            <>
              <Container sx={{ marginBottom: 2 }}>
                <Box
                // sx={{
                //   display: "flex",
                //   flexDirection: { xs: "column", sm: "row" }, // Column for small screens, row for larger
                //   alignItems: { xs: "center", sm: "center" }, // Center-align for small screens
                //   justifyContent: { sm: "space-between" }, // Space-between for larger screens
                //   gap: { xs: 2, sm: 0 }, // Add vertical spacing between buttons on small screens
                //   textAlign: { xs: "center", sm: "left" }, // Center-align text on small screens
                // }}
                >
                  <Box>
                    <Typography
                      variant="h5"
                      component="h2"
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <Apartment color="action" /> {property.propertyType.name}
                    </Typography>
                    <Typography
                      variant="h6"
                      component="p"
                      color="text.secondary"
                    >
                      Available Room{units.ids.length > 1 && "s"}
                    </Typography>
                  </Box>
                </Box>
              </Container>

              <Container sx={{ marginBottom: 5 }}>
                <Grid2 container spacing={3}>
                  {units.ids.map((id) => (
                    <Grid2 key={id} size={{ xs: 12, sm: 6, md: 4 }}>
                      <PublicUnitCard
                        key={id}
                        unit={units.entities[id]} // Access unit details via ID
                        property={property}
                      />
                    </Grid2>
                  ))}
                </Grid2>
              </Container>
            </>
          )}
        </>
      )}
    </>
  );
};

export default PublicUnitGrid;
